












































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Motion extends Vue {
  id = null;
  apps = ["scanner", "translator"];
  envs = ["dev", "prod"];
  app = "scanner";
  env = "dev";
  user: { notificationArn?: string } = {};
  title = null;
  body = null;
  category = null;
  alertTitleLocKey = null;
  alertBodyLocKey = null;
  alertTitleLocArgs = null;
  alertBodyLocArgs = null;

  find() {
    fetch(
      `${
        this.env === "dev"
          ? process.env.VUE_APP_PUSH_URL_DEV
          : process.env.VUE_APP_PUSH_URL_PROD
      }user?id=${encodeURIComponent(`${this.app}#${this.id}`)}`
    )
      .then(response => response.json())
      .then(user => (this.user = user));
  }
  send() {
    fetch(
      `${
        this.env === "dev"
          ? process.env.VUE_APP_PUSH_URL_DEV
          : process.env.VUE_APP_PUSH_URL_PROD
      }send-push`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: `${this.app}#${this.id}`,
          notificationArn: this.user.notificationArn,
          title: this.title,
          body: this.body,
          category: this.category,
          alertTitleLocKey: this.alertTitleLocKey,
          alertBodyLocKey: this.alertBodyLocKey,
          alertTitleLocArgs: this.alertTitleLocArgs,
          alertBodyLocArgs: this.alertBodyLocArgs
        })
      }
    ).then(response => response.json());
  }
}
